import { keywordWidth, maxBarLength, titleIndent } from './constants';
import React from 'react';
import { FaEye, FaExternalLinkAlt, FaFilePdf } from 'react-icons/fa';
import { getDisplayName } from '../utils';
import { useAppState } from '../../AppContext';
import PropTypes from 'prop-types';

const DocumentTitles = ({ cluster, startY }) => {
  let [
    { documents, selectedDocument, mousedOverDocument },
    dispatch
  ] = useAppState();

  const openDocPreview = (doc, document) => {
    // NB. this remembers page number for only the most recently opened PDF. Could instead save array of page number for each document.
    if (selectedDocument.id !== doc.document_id) {
      dispatch({
        type: 'SET_SELECTED_DOCUMENT',
        selectedDocument: {
          id: doc.document_id,
          filename: document.filename
        }
      });

      dispatch({ type: 'SET_PAGE_NUMBER', pageNumber: 1 });
    }

    dispatch({
      type: 'SET_PDF_MODAL_OPEN',
      pdfModalOpen: true
    });
  };

  const externalLinkField = process.env.REACT_APP_EXTERNAL_LINK_FIELD;
  const externalLinkTitle = process.env.REACT_APP_EXTERNAL_LINK_TITLE;

  return (
    <>
      <g transform={`translate(0, ${15 + keywordWidth})`}>
        {/* horizontal stripes */}
        {[...Array(cluster.members.length + 1).keys()].map((doc, i) => (
          <line
            key={`stripe-${i}`}
            x1={0}
            x2={maxBarLength + titleIndent}
            y1={startY + i * keywordWidth}
            y2={startY + i * keywordWidth}
            stroke={'grey'}
            style={{ opacity: 0.2 }}
          >
            <title>{cluster.members.length}</title>
          </line>
        ))}
      </g>

      <g
        transform={`translate(${maxBarLength + titleIndent}, ${
          15 + keywordWidth
        })`}
      >
        {cluster.members.map((doc, doc_index) => {
          const document = documents.filter((d) => doc.document_id === d.id)[0];
          const rowY = startY + doc_index * keywordWidth + 0.5 * keywordWidth;

          const highlighted =
            mousedOverDocument === doc.document_id ||
            selectedDocument.id === doc.document_id;

          const displayName = getDisplayName(
            documents.filter((d) => doc.document_id === d.id)[0]
          );

          return (
            <React.Fragment key={doc_index}>
              <g transform={`translate(0 ,${rowY - 10})`}>
                {/* background rect to provide a larger click target */}
                <rect
                  x={'-0.5em'}
                  y={0}
                  width={'1.75em'} /* actual glyph fits in a 1em by 1em box */
                  height={'1.25em'}
                  fill={'white'}
                  stroke={'none'}
                  onClick={() => openDocPreview(doc, document)}
                />

                <FaEye
                  fill={highlighted ? 'gold' : 'grey'}
                  title={'View PDF in modal pane.'}
                  onClick={() => openDocPreview(doc, document)}
                />
              </g>

              <g transform={`translate(20 ,${rowY - 10})`}>
                <a
                  href={`/api/uploads/${document.id}/${document.filename}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFilePdf
                    fill={highlighted ? 'gold' : 'grey'}
                    title={'Open PDF in new tab.'}
                  />
                </a>
              </g>

              {externalLinkField && (
                <g transform={`translate(40 ,${rowY - 10})`}>
                  <a
                    href={`${document[externalLinkField]}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaExternalLinkAlt
                      fill={highlighted ? 'gold' : 'grey'}
                      title={
                        externalLinkTitle
                          ? externalLinkTitle
                          : 'External link to document'
                      }
                    />
                  </a>
                </g>
              )}

              <text
                key={doc_index}
                id={`document-${doc.document_id}`}
                x={externalLinkField ? 60 : 40}
                y={rowY + 4}
                onClick={() => openDocPreview(doc, document)}
                onMouseOver={() => {
                  dispatch({
                    type: 'SET_MOUSED_OVER_DOCUMENT',
                    mousedOverDocument: doc.document_id
                  });
                }}
                onMouseOut={() => {
                  dispatch({
                    type: 'SET_MOUSED_OVER_DOCUMENT',
                    mousedOverDocument: null
                  });
                }}
                style={{ cursor: 'pointer' }}
                fill={highlighted ? 'black' : 'gray'}
                fontWeight={highlighted ? 'bold' : 'normal'}
              >
                {displayName}
                <title>{displayName}</title>
              </text>
            </React.Fragment>
          );
        })}
      </g>
    </>
  );
};

DocumentTitles.propTypes = {
  cluster: PropTypes.shape({
    members: PropTypes.array.isRequired,
    expanded: PropTypes.bool.isRequired,
    keywords: PropTypes.arrayOf(PropTypes.string)
  }),
  startY: PropTypes.number
};

export default DocumentTitles;
